import axios from 'axios'
import React, { useState } from 'react'
import { Form, Modal, Spinner } from 'react-bootstrap'
import ReactPlayer from 'react-player'
import demoImg from '../../../assets/images/demoLogoImg.png'
import { VendorAdCreateEnd, FileUploadEnd } from '../../../constants/api.constants'
import Toast from '../../../utils/Toast/Toast'
import './VendorAddAdModal.scss'

const VendorAddAdModal = ({ show, handleClose, loadAds }) => {
    const [photoSpinner, setPhotoSpinner] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [photoUrl, setPhotoUrl] = useState('')

    const [data, setData] = useState({
        name: '',
        description: '',
        link: '',
        type: 'photo',
    })

    const handleImageUpload = async (e) => {
        setPhotoSpinner(true)
        if (!e.target.files || e.target.files.length === 0) {
            setPhotoSpinner(false)
            setPhotoUrl(null)
            return
        }
        const file = e.target.files[0]
        const fileName = file.name
        const fileExtension = fileName.split('.').pop().toLowerCase()
        const formData = new FormData()
        formData.append('files', file)

        if (fileExtension !== 'webp') {
            try {
                const res = await axios.post(FileUploadEnd, formData, {
                    headers: {
                        menuboard: localStorage.getItem('vendor_token'),
                    },
                })
                if (res.status === 200) {
                    setPhotoUrl(res.data?.files[0]?.path)
                    setPhotoSpinner(false)
                    Toast('success', 'File uploaded successfully')
                }
            } catch (error) {
                setPhotoSpinner(false)
                setPhotoUrl(null)
                Toast('err', error.response?.data?.msg || 'Upload failed')
            }
        } else {
            Toast('err', 'Invalid image format')
            setPhotoSpinner(false)
            setPhotoUrl(null)
        }
    }

    const handleCloseReset = () => {
        setData({
            name: '',
            description: '',
            link: '',
            type: 'photo',
        })
        setPhotoUrl('')
    }

    const handleCreateNewAd = async () => {
        setSpinner(true)

        if (!photoUrl) {
            Toast('err', 'Media file must be provided')
            setSpinner(false)
            return
        }

        if (!data?.name) {
            Toast('err', 'Please enter ad name')
            setSpinner(false)
            return
        }

        if (!data.description) {
            Toast('err', 'Please enter description')
            setSpinner(false)
            return
        }

        try {
            const response = await axios.post(
                VendorAdCreateEnd,
                {
                    name: data?.name,
                    description: data?.description,
                    link: photoUrl,
                    type: data?.type,
                },
                {
                    headers: {
                        menuboard: localStorage.getItem('vendor_token'),
                    },
                }
            )

            if (response.status === 200) {
                Toast('success', 'Ad created successfully!')
                handleClose()
                setSpinner(false)
                handleCloseReset()
                loadAds()
            } else {
                throw new Error(response.data?.msg || 'Try again later')
            }
        } catch (error) {
            setSpinner(false)
            Toast('err', error.response?.data?.msg || 'Failed to create ad')
        }
    }

    return (
        <Modal show={show} onHide={() => { handleClose(); handleCloseReset() }} size='lg'>
            <Modal.Header closeButton style={{ border: 'none' }}>
                <Modal.Title style={{ fontSize: '22px' }}>Upload New Ad</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex justify-content-start align-items-end'>
                    {data?.type === 'photo' ? (
                        <img
                            src={photoUrl || demoImg}
                            alt=''
                            height='100'
                            width='200'
                            className='me-4'
                            style={{ objectFit: 'cover', borderRadius: '8px' }}
                        />
                    ) : (
                        <div className='mx-3'>
                            <ReactPlayer
                                url={photoUrl || demoImg}
                                width='200px'
                                height='100px'
                                controls={true}
                            />
                        </div>
                    )}

                    <Form.Group className='' controlId='formBasicEmail'>
                        <Form.Label>
                            {data?.type === 'photo' ? 'Image' : 'Video'}*
                            {photoSpinner && (
                                <Spinner className='ms-1' animation='border' size='sm' />
                            )}
                        </Form.Label>
                        <Form.Control type='file' onChange={(e) => handleImageUpload(e)} />
                    </Form.Group>
                </div>

                <div className='my-3'>
                    <div className='plain-input my-3'>
                        <label htmlFor=''>Ad Name*</label>
                        <br />
                        <input
                            type='text'
                            placeholder='Enter name'
                            value={data.name}
                            onChange={(e) => setData({ ...data, name: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleCreateNewAd()
                                }
                            }}
                        />
                    </div>
                    <div className='plain-input my-3'>
                        <label htmlFor=''>Description*</label>
                        <br />
                        <input
                            type='text'
                            placeholder='Enter details'
                            value={data.description}
                            onChange={(e) => setData({ ...data, description: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleCreateNewAd()
                                }
                            }}
                        />
                    </div>

                    <div className='plain-dropdown my-3'>
                        <label htmlFor=''>File Type*</label>
                        <br />
                        <select
                            className=''
                            value={data.type}
                            onChange={(e) => setData({ ...data, type: e.target.value })}
                        >
                            <option value='photo'>Photo</option>
                            <option value='video'>Video</option>
                        </select>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ border: 'none' }}>
                <button className='primary-btn-light' onClick={() => { handleClose(); handleCloseReset() }}>
                    Close
                </button>
                <button
                    className='primary-btn'
                    onClick={() => handleCreateNewAd()}
                    disabled={spinner}
                >
                    Save Changes{' '}
                    {spinner && <Spinner animation='border' size='sm' className='ms-2' />}
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default VendorAddAdModal
